const Entidad = "OneClickSgr";
const GoogleMapKey = "AIzaSyDwKzicjMvfVsf9SbEAZn9N7i4CxX6YO1I";
const RecaptchaKey = "6Ld12vweAAAAABc9nxruyLdu5XWJqS5fomtrCswd";
const UrlApiDynamics = "https://sgroc365api.azurewebsites.net/api/";
const UnidadDeNegocio = "1ABDE9D1-7B18-EC11-B6E6-000D3A886E91"

const UrlApi = "https://api-educativa-uat.azurewebsites.net/"


const authMail = "admin@hrfactorsues21uat.com"
const authPass = "Hrues21uat.2023"


export { Entidad, GoogleMapKey, RecaptchaKey, UrlApiDynamics, UnidadDeNegocio, UrlApi, authMail, authPass }